import { apiClient } from './client';
import type { Customer, CreateCustomerInput, UpdateCustomerInput, License } from '../../types';

export const customersService = {
  list: async (params?: { limit?: number; offset?: number; status?: string; query?: string }): Promise<{ customers: Customer[] }> => {
    return apiClient.get<{ customers: Customer[] }>('/api/v1/customers', params);
  },

  getStats: async (): Promise<{ total: number }> => {
    return apiClient.get('/api/v1/customers/stats');
  },

  getById: async (id: string): Promise<Customer> => {
    return apiClient.get<Customer>(`/api/v1/customers/${id}`);
  },

  search: async (q: string, limit?: number): Promise<{ customers: Customer[] }> => {
    return apiClient.get<{ customers: Customer[] }>('/api/v1/customers/search', { q, limit });
  },

  getLicenses: async (id: string): Promise<{ licenses: License[] }> => {
    return apiClient.get<{ licenses: License[] }>(`/api/v1/customers/${id}/licenses`);
  },

  create: async (input: CreateCustomerInput): Promise<Customer> => {
    return apiClient.post<Customer>('/api/v1/customers', input);
  },

  update: async (id: string, input: UpdateCustomerInput): Promise<Customer> => {
    return apiClient.patch<Customer>(`/api/v1/customers/${id}`, input);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/v1/customers/${id}`);
  },
};
